<div class="container check-ip-content">
  <div class="section-title">
    <div>Пользователи с IP:
      <a href="https://check-host.net/ip-info?host={{ip}}" target="_blank">{{ip}}</a>
    </div>
  </div>

  <mat-divider class="divider"></mat-divider>

  <div class="tables-container">
    <div class="by-account-ip">
      <h3>Список пользователей по IP аккаунтов: </h3>
      <mat-table [dataSource]="byAccountDataSource" class="table by-account-ip-table">

        <!-- count Column -->
        <ng-container matColumnDef="count">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let element; let i=index">{{i + 1}}</mat-cell>
        </ng-container>

        <!-- user Column -->
        <ng-container matColumnDef="user">
          <mat-header-cell *matHeaderCellDef>Пользователь</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="ellipsis-text"><a [routerLink]="['../../../../', element.id]">{{element.name}}</a></span>
          </mat-cell>
        </ng-container>

        <!-- balance Column -->
        <ng-container matColumnDef="balance">
          <mat-header-cell *matHeaderCellDef>Баланс</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element.coinsAmount | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast">
                {{element.coinsAmount / 100 | customCurrency}}
              </span>
          </mat-cell>
        </ng-container>

        <!-- date Column -->
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef>Зарегистрирован</mat-header-cell>
          <mat-cell *matCellDef="let element">  {{element.dateAdded | date: 'dd.MM.yy HH:mm'}}</mat-cell>
        </ng-container>

        <!-- locked Column -->
        <ng-container matColumnDef="locked">
          <mat-header-cell *matHeaderCellDef>Заблокирован</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.isLocked ? 'Да' : 'Нет' }}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="usersListColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: usersListColumns;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <mat-paginator #paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
    </div>

    <mat-divider class="divider"></mat-divider>

    <div class="by-auth-ip">
      <h3>Список пользователей по истории входов с этим IP: </h3>
      <mat-table [dataSource]="byAuthDataSource" class="table by-auth-ip-table">

        <!-- count Column -->
        <ng-container matColumnDef="count">
          <mat-header-cell *matHeaderCellDef>#</mat-header-cell>
          <mat-cell *matCellDef="let element; let i=index">{{i + 1}}</mat-cell>
        </ng-container>

        <!-- user Column -->
        <ng-container matColumnDef="user">
          <mat-header-cell *matHeaderCellDef>Пользователь</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <span class="ellipsis-text">
              <a [routerLink]="['../../../../', element.steamid64]">{{element.name}}</a>
            </span>
          </mat-cell>
        </ng-container>

        <!-- balance Column -->
        <ng-container matColumnDef="balance">
          <mat-header-cell *matHeaderCellDef>Баланс</mat-header-cell>
          <mat-cell *matCellDef="let element">
              <span
                matTooltip="{{element.bonus_points | fastCoinsToDollar}}"
                matTooltipPosition="above"
                [matTooltipDisabled]="!isGoFast">
                {{element.bonus_points / 100 | customCurrency }}
              </span>
          </mat-cell>
        </ng-container>

        <!-- login_at Column -->
        <ng-container matColumnDef="login_at">
          <mat-header-cell *matHeaderCellDef>Залогинен</mat-header-cell>
          <mat-cell *matCellDef="let element">  {{element.date_login | date: 'dd.MM.yy HH:mm'}}</mat-cell>
        </ng-container>


        <!-- date Column -->
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef>Зарегистрирован</mat-header-cell>
          <mat-cell *matCellDef="let element">  {{element.date_added | date: 'dd.MM.yy HH'}}</mat-cell>
        </ng-container>

        <!-- locked Column -->
        <ng-container matColumnDef="locked">
          <mat-header-cell *matHeaderCellDef>Заблокирован</mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.is_locked ? 'Да' : 'Нет' }}</mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="usersListByAuthColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: usersListByAuthColumns;"></mat-row>

        <div class="empty-data" *matNoDataRow>
          <p>Данные отсутствуют</p>
        </div>
      </mat-table>
      <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
      <mat-paginator #paginatorByAuth [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
    </div>
  </div>
</div>
